<app-sidenav-v2 [shortMenu]="true" style="display: flex; height: 100%;">
    <app-pipelines-tramites-table [headers]="headers" [data]="data" [summary]="summary" style="overflow-y: auto;"></app-pipelines-tramites-table>
</app-sidenav-v2>